import { IProduct, DiscountTypes } from "@/api/AppApi/services/home/interfaces/IProduct";

import { ProductUnitPriceDefaults } from "@/api/AppApi/services/company/interfaces/ICompany";

// extract the type from the array of that type
type Unpack<T> = T extends (infer U)[] ? U : T;

type TParams1 = {
  originalPrice: number;
  originalPriceWithoutDiscount: number;
  unitId?: number;
  originalDiscountAmount?: number;
  originalDiscountType?: DiscountTypes;
  originalDiscount?: number;
  defaultProductUnitPrice?: ProductUnitPriceDefaults;
};

type TParams2 = {
  specialPrices: IProduct["selling_prices"];
  quantity: number;
};

const calculatPricesForSpecialPrices =
  ({
    originalPrice,
    originalPriceWithoutDiscount,
    unitId,
    originalDiscountAmount,
    originalDiscountType,
    originalDiscount,
    defaultProductUnitPrice,
  }: TParams1) =>
  ({ specialPrices, quantity }: TParams2) => {
    const sortedSpecialPrices = [...(specialPrices || [])].sort((a, b) => {
      if (defaultProductUnitPrice === ProductUnitPriceDefaults.highest_price) {
        return b.price - a.price;
      }
      return a.price - b.price;
    });
    const matchWithRule = checkQuantityUnitRuleMatch(quantity, unitId);
    const matchedSpecialPrice = sortedSpecialPrices.find(matchWithRule);
    
    if (matchedSpecialPrice?.price) {
      return {
        price: matchedSpecialPrice.price,
        price_without_discount: matchedSpecialPrice.price_without_discount,
        discount_amount: matchedSpecialPrice.discount_amount,
        discount_type: matchedSpecialPrice.discount_type || originalDiscountType,
        discount: matchedSpecialPrice.discount ?? originalDiscount,
        unit_id: matchedSpecialPrice.unit_id
      };
    }

    return {
      price_without_discount: originalPriceWithoutDiscount,
      price: originalPrice,
      discount_amount: originalDiscountAmount,
      discount_type: originalDiscountType,
      discount: originalDiscount,
      unit_id: unitId
    };
  };

export default calculatPricesForSpecialPrices;

const checkQuantityUnitRuleMatch =
  (quantity: number, unit_id?: number) =>
  (specialPrice: Unpack<IProduct["selling_prices"]>) => {
    const operators: Record<1, Function> = {
      "1": () => {
        if (unit_id) {
          return (
            unit_id === specialPrice.unit_id &&
            quantity >= specialPrice.quantity
          );
        }
        return quantity >= specialPrice.quantity;
      },
    };
    return operators["1"]();
  };
